import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { handleOAuthSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/');
      return;
    }

    (async () => {
      try {
        const data = await handleOAuthSession(sessionId);
        const role = data.user?.role;
        if (role === 'parent') navigate('/parent', { replace: true });
        else if (role === 'admin') navigate('/admin', { replace: true });
        else navigate('/home', { replace: true });
      } catch (err) {
        console.error('OAuth callback error:', err);
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, handleOAuthSession]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#FFF8F0' }}>
      <div className="text-center animate-slide-up">
        <div className="text-5xl mb-4">🦉</div>
        <p className="text-lg font-bold text-[#1B4F8A]">Logging you in...</p>
      </div>
    </div>
  );
}
